export interface JwtClaims {
  sub: string
  apiBaseUrl: string
  accountBaseUrl: string
  websocketBaseUrl: string
  userId: string
  namespace?: string
}

export function parseJwt(token: string): JwtClaims {
  if (!token) {
    throw new Error('Token parsing failed: Missing auth token')
  }

  try {
    // Auth0 tokens can have query params appended: "jwt?param=value"
    const [jwtPart, queryPart] = token.split('?')

    const parts = jwtPart.split('.')
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format')
    }

    const payloadStr = atob(parts[1])
    const jwtPayload = JSON.parse(payloadStr)

    // Merge query params if present
    if (queryPart) {
      const params = new URLSearchParams(queryPart)
      params.forEach((value, key) => {
        jwtPayload[key] = value
      })
    }

    const apiBaseUrl = jwtPayload['BaseApplication/apiBaseUrl']
    if (!apiBaseUrl) {
      throw new Error('Token missing apiBaseUrl')
    }

    const websocketBaseUrl = jwtPayload['BaseApplication/websocketBaseUrl'] || ''
    const accountBaseUrl = jwtPayload['BaseApplication/accountBaseUrl'] || apiBaseUrl

    return {
      sub: jwtPayload.sub || '',
      apiBaseUrl,
      accountBaseUrl,
      websocketBaseUrl,
      userId: jwtPayload['BaseApplication/userId'] || '',
      namespace: jwtPayload['BaseApplication/namespace']
    }
  } catch (err) {
    if (err instanceof Error && err.message.startsWith('Token')) {
      throw err
    }
    const message = err instanceof Error ? err.message : 'Failed to parse token'
    throw new Error(`Token parsing failed: ${message}`)
  }
}
